import { useMutation } from "react-query";
import getAllocateSku from "../services/getAllocateSku";

function useAllocateSku() {
  return useMutation(["allocate-sku"], getAllocateSku);
}

export default useAllocateSku;
